import type { BannerView } from "@/client-types/service-status";

/**
 * Keyed on the message itself rather than a fixed id, so a dismissal only silences the message the
 * reader actually saw — a new one shows up again. updatedAt is left out on purpose: bumping the
 * timestamp on an unchanged message should not make it reappear.
 */
export function buildDismissKey(banner: BannerView): string {
  return `service-banner-dismissed:${banner.title}\u0000${banner.message}`;
}
